import { Component, OnInit } from '@angular/core';
import {} from 'googlemaps';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import{Servicio} from '../servicio/servicio';
import { ViewChild } from '@angular/core';
@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css']
})
export class MapsComponent implements OnInit {
  @ViewChild('map', {static: true}) mapElement: any;
  map: google.maps.Map;
  estado_vista=false;
  nombre_maps="";
  direccion_maps="";
  telefono_maps="";
  telefono="";
  constructor(public servicio:Servicio,private router: Router) { }
  ngOnInit() {
    const mapProperties = {
      center: new google.maps.LatLng(-8.4088808,-75.6257318),
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.ROADMAP
 };
 this.map = new google.maps.Map(this.mapElement.nativeElement,    mapProperties);
 this.setMarkers(this.map);
  }
  login(){
    this.router.navigate(['/login']);
  }
  setMarkers(map) {
    var image = {
      url: '../../assets/favicon.ico',
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 32)
    };

    this.servicio.enviar_seguro("api/ws_clselagencias",{},sessionStorage.getItem("token")).pipe().subscribe(
      response=>{
            if(response["status"]==200){
              response["response"].forEach(element => {


         if(element["Latitud"]!=null){
                var marker = new google.maps.Marker({
                  position: {lat:parseFloat( element["Latitud"].toString()), lng: parseFloat(element["Longitud"].toString())},
                  map: map,
                  icon: image,
              
                  title: element["nombreAgencia"].toString(),
                  zIndex: parseFloat("2"),
                  
                });
                this.attachSecretMessage(marker, element, element["nombreAgencia"].toString(), element["DIRECCION"].toString(), element["TELEFONOS"].toString());
              }
       
       
              });
  
            }else{
            }
      }  ,
      error => {
      }
  );
  }
  attachSecretMessage(marker, secretMessage,nombre,direccion,telefono)
   {
        var infowindow = new google.maps.InfoWindow({
          content: secretMessage["nombre"]
        });
        var _this=this;
        marker.addListener('click', function() {
          _this.estado_vista=true;
          _this.nombre_maps="Agencia "+nombre;
          _this.direccion_maps=direccion;
          _this.telefono_maps="Telefono: "+telefono;
          _this.telefono=telefono;
        });
    }
  cerrar(){
    this.estado_vista=false;
  }

}
